import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AnnouncementBannerComponent } from '../../announcement-banner/announcement-banner.component';

import { ApiloaderService } from '../../loaders/apiloader/apiloader.service';
import { ApiloaderWidgetComponent } from '../../loaders/apiloader/apiloaderwidget.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  standalone: true,
  imports: [NgIf, ApiloaderWidgetComponent, AnnouncementBannerComponent],

  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  // These allow parent components to pass data in
  private _branchName: string = '';

  @Input()
  set branchName(value: string) {
    if(value !== '') {
      this._branchName = `Branch: ${value}`;
    }
  }
  get branchName(): string {
    return this._branchName;
  }

  // 1. Accepts the environment name from app.component.html
  @Input() environmentName: string = '';
  @Input() userRole: string = '';

  constructor(public loaderService: ApiloaderService) { }
  showMemorialBanner: boolean = true;
  ngOnInit() {
    // Check if the user has already dismissed the banner
    const isDismissed = localStorage.getItem('memorial_dismissed');
    if (isDismissed) {
      this.showMemorialBanner = false;
    }
  }
  closeBanner() {
    this.showMemorialBanner = false;
    localStorage.setItem('memorial_dismissed', 'true');
  }
}
